import { useUserStore } from "~/stores/user";

export default function ({ app, redirect, route, $logger }) {
  // Only run on client side to avoid SSR issues
  if (process.server) {
    return;
  }

  const userStore = useUserStore();

  if (!userStore.me || !userStore.me.locale || userStore.isAdmin) {
    return;
  }

  const userLocale = userStore.me.locale;
  const currentLocale = app.i18n.locale;

  // If user's locale matches current locale, no action needed
  if (userLocale === currentLocale) {
    return;
  }

  // Check if user's locale is available for current brand
  const availableLocales = app.i18n.locales.map((l) => l.code);
  if (!availableLocales.includes(userLocale)) {
    $logger.warn(
      `User's preferred locale "${userLocale}" is not available for current brand`
    );
    return;
  }

  // Redirect to the same page but in user's preferred locale
  try {
    const localizedPath = app.switchLocalePath(userLocale);
    if (localizedPath && localizedPath !== route.fullPath) {
      $logger.info(
        `Redirecting user from locale "${currentLocale}" to preferred locale "${userLocale}"`
      );
      redirect(localizedPath);
    }
  } catch (error) {
    $logger.error("Error redirecting to user's locale", error);
  }
}
